<template>
  <div
    class="kd-grafik-layer"
    :style="{ backgroundImage: backgroundImageUrlCss }"
  ></div>
</template>

<script>
export default {
  props: {
    layer: Object,
  },
  data() {
    return {
      imageUrl: '',
    };
  },
  computed: {
    // imageUrl() {
    //   if (this.layer && this.layer.imageUrl) { return this.layer.imageUrl; }
    //   return ''; // TODO: return Placeholder image!?
    // },
    backgroundImageUrlCss() {
      return `url(${this.baseUrl}${this.imageUrl})`;
    },
    baseUrl() {
      return process.env.VUE_APP_IMAGE_SERVER;
    },
    storedImageUrl() {
      if (this.layer && this.layer.imageUrl) {
        return this.layer.imageUrl;
      }
      return '';
    },
  },
  mounted() { this.updateImageUrl(); },
  updated() { this.updateImageUrl(); },
  watch: {
    storedImageUrl() { this.updateImageUrl(); },
  },
  methods: {
    updateImageUrl() { this.imageUrl = this.layer.imageUrl; },
  },
};
</script>

<style lang="scss">
.kd-grafik-layer {
  width: 100%;
  height: 100%;
  background-size: cover;
}
</style>
